import { LoadingButton } from '@mui/lab';
import { SmallLoading } from '../../../../Component/Common/Components/Loading/IntermediateLoading';
import { CustomDialogTitle } from '../../../Common/Custom/CustomDialogTitle';
import AppSelectList from '../../../../Component/Common/Components/FormValidationInputs/AppSelectList';
import AppTextInput from '../../../../Component/Common/Components/FormValidationInputs/AppTextInput';
import { Box, Dialog, DialogActions, DialogContent, Grid } from '@mui/material';
import { useEffect } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FeedbackValidationSchema } from '../FeedbackValidationSchema';
import {
    companyTypeList,
    ratingList,
} from '../../../../Component/Common/Constants/Lists/DropdownListOptions';
import AppYesOrNoSelector from "../../../../Component/Common/Components/FormValidationInputs/AppYesOrNoSelector";
import {
    VerificationAgencyClientService
} from "../../../../Component/Api/VerificationAgency/VerificationAgencyClient/VerificationAgencyClientService";
import { VerificationAgencyClient } from "../../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClient";
import { MDTypography } from "../../../../Component/Common/Components/MDTypography";
import { Guid } from "guid-typescript";

interface IProps {
    companyName?: string;
    vaClientId?: number;
    vaClientApplicationId?: number;
    token: Guid;
    setSubmitted: (i: boolean) => void;
}

export const FeedbackCaptureExternalPage = (props: IProps) => {

    const { control, watch, setValue, handleSubmit, formState: { isSubmitting } } = useForm({
        mode: 'all',
        resolver: yupResolver(FeedbackValidationSchema)
    });

    const isSatisfied = watch("isSatisfied", true);

    const handleDataSubmit = async (data: FieldValues) => {

        try {
            const finalData = data as VerificationAgencyClient.FeedbackDetailDto;
            finalData.vaClientId = props.vaClientId;
            finalData.token = props.token;
            finalData.vaClientApplicationId = props.vaClientApplicationId;

            const response = await VerificationAgencyClientService.CreateFeedbackEntry(finalData);
            props.setSubmitted(true);
            toast.success("Feedback created");

        } catch (error) {
            toast.error("Something went wrong. Feedback not created");
        }
    }

    useEffect(() => {
        setValue("companyName", props.companyName);
    }, [props.companyName]);

    return (
        <Box width="100%" display="flex" justifyContent="center">
            <Grid container component="form" id='FeedbackDetailsForm' onSubmit={handleSubmit(handleDataSubmit)} ml={15} mr={15}>
                <Grid item xs={12}>
                    <MDTypography graphy color='primary' variant='h6' fontWeight='bold'>
                        Capture Feedback Details
                    </MDTypography>
                </Grid>
                <Grid item xs={12}>
                    <Box mt={2}>
                        <AppTextInput control={control} name="companyName" label="Name of Company" disabled={true} />
                    </Box>
                    <Box mt={2}>
                        <AppTextInput control={control} name="clientName" label="What is your name and surname?" />
                    </Box>
                    <Box mt={2}>
                        <AppTextInput control={control} name="analystName" label="Who was your verification analyst?" />
                    </Box>
                    <Box mt={2}>
                        <AppYesOrNoSelector control={control} name="isSatisfied" label='Are you satisfied with your verification result?' size="small" />
                    </Box>
                    {!isSatisfied &&
                        <Box mt={2}>
                            <AppTextInput control={control} name="reason" label="If not, please elaborate?" size={"small"} multiline={true} rows={4} />
                        </Box>
                    }
                    <Box mt={2}>
                        <AppYesOrNoSelector control={control} name="isRequirementsUnderstood" label='Did the verification analyst understand your organisations BBBEE Requirements?' size="small" />
                    </Box>
                    <Box mt={2}>
                        <AppYesOrNoSelector control={control} name="isProfessional" label='Did your verification analyst conduct themselves in a professional manner at all times?' size="small" />
                    </Box>
                    <Box mt={2}>
                        <AppSelectList control={control} name='analystRating' label='How would you rate your experience with your verification analyst?' items={ratingList} size="small" />
                    </Box>
                    <Box mt={2}>
                        <AppSelectList control={control} name='premierRating' label='Overall, how would you rate your experience with the Verification Agency?' items={ratingList} size="small" />
                    </Box>
                    <Box mt={2}>
                        <AppYesOrNoSelector control={control} name="wouldRefer" label='Would you refer The Verification Agency`s services to anyone else?' size="small" />
                    </Box>
                    <Box mt={2}>
                        <AppTextInput control={control} name="improvementFeedback" label="Is there anything we could have done to improve your verification experience?" size={"small"} multiline={true} rows={4} />
                    </Box>
                    <Box mt={2} width='100%' display='flex' justifyContent='flex-end'>
                        <LoadingButton loading={isSubmitting} variant='contained' form='FeedbackDetailsForm' type="submit" color='primary'>
                            Submit
                        </LoadingButton>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}
